import { customAlphabet } from 'nanoid';

const generateUniqueNumber = customAlphabet('0123456789', 5);

export const generateUniqueID = (prefix: string) => {
	const year = new Date().getFullYear();
	const uniqueNumber = generateUniqueNumber();
	const timestamp = Date.now().toString().slice(-4);
	return `${prefix}-${year}-${uniqueNumber}${timestamp}`;
};
